import axios from 'axios';
import { BASE_URL } from './constants';

const instance = axios.create({
  baseURL: BASE_URL + '/api',
});

instance.interceptors.request.use((request) => {

  let token = JSON.parse(localStorage.getItem('token'))

  request.headers = {
    'Accept': "application/json, text/plain, */*",
    'Authorization': `Bearer ${token}`,
  }
  return request
});

instance.interceptors.response.use((response) => {
  if (response) {
    return response
  }
}, (error) =>
  Promise.reject(
    error
  )
);

export default instance;